import { render, staticRenderFns } from "./ImageView.vue?vue&type=template&id=b7674414&scoped=true"
import script from "./ImageView.vue?vue&type=script&lang=ts"
export * from "./ImageView.vue?vue&type=script&lang=ts"
import style0 from "./ImageView.vue?vue&type=style&index=0&id=b7674414&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7674414",
  null
  
)

export default component.exports